import { ApolloClient, InMemoryCache } from '@apollo/client'
import { ApolloLink } from '@apollo/client/core'
import { createUploadLink } from 'apollo-upload-client'

import { GRAPHQL_ENDPOINT } from '@/constants'

import authLink from './authLink'
import typePolicies from './typePolicies'

const linkOptions = {
  // credentials: "include",
  uri: GRAPHQL_ENDPOINT,
}

const uploadLink = createUploadLink(linkOptions)

export default new ApolloClient({
  cache: new InMemoryCache({ typePolicies }),
  link: authLink.concat(uploadLink as ApolloLink),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
})
